export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
export const GOOGLE_PLACES_API_KEY = process.env.REACT_APP_GOOGLE_PLACES_API_KEY || '';
